export default "__VITE_ASSET__BlIpAxcS__"